import { ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './LeadersClub.module.css';

type Props = {
  leaders: ReactNode;
  size?: 'small' | 'medium' | 'large';
};

export function LeadersClub({ leaders, size = 'large' }: Props) {
  return (
    <div className={cx(styles.root, styles[`size_${size}`])}>
      <div className={styles.panel}>
        <div className={styles.content}>{leaders}</div>
      </div>
    </div>
  );
}
